import * as _ from 'bootstrap-autocomplete';

import { createVue } from '@/app';
import { Modal } from 'bootstrap';

$.fn.button = {
	Constructor: { VERSION: '4' },
};

const origHtml = $.fn.html;
$.fn.html = function (value) {
	const ret = origHtml.apply(this, [value]);
	for (const el of this) {
		let app = el['__cybsis_vue'];
		if (app) app.unmount();

		app = createVue();
		el['__cybsis_vue'] = app;
		app.mount(el);
	}
	return ret;
};

let animationInProgress = false;
function openProperties() {
	if (animationInProgress) {
		return false;
	}

	animationInProgress = true;

	var propertyWindowWidth = '25%';
	var ratio = 0.25;

	if ($('#property-window').hasClass('col-md-4')) {
		propertyWindowWidth = '33.3333333333%';
		ratio = 0.333333333333;
	}

	if ($('#property-window').hasClass('col-md-5')) {
		propertyWindowWidth = '41.6666666667%';
		ratio = 0.416666666667;
	}

	var width = $('#property-window').hasClass('expanded') ? 0 : propertyWindowWidth;

	let childWidth = $('#property-window').parent().outerWidth() * ratio;
	$('#property-window')
		.children()
		.each(function (i, child) {
			$(child).css('width', childWidth + 'px');
		});

	$('#property-window').animate(
		{
			width: width,
			overflow: 'hidden',
		},
		{
			duration: 300,
			queue: false,
			complete: function () {
				if (width == 0) {
					$('#property-window').removeClass('expanded');
				} else {
					$('#property-window').addClass('expanded');
					$('#property-window').css('width', '');
				}
				animationInProgress = false;
			},
		},
	);
}

let toaster;

export function legacyReady(toastStore) {
	toaster = toastStore;

	$('#property-window').click(function (e) {
		e.stopImmediatePropagation();
	});

	$('.btn-close, .close-btn').click(function (e) {
		e.stopImmediatePropagation();
	});

	let isDryRun = true;
	// TODO refacto for multi instance
	$('#upgrade-eits-btn').click(() => {
		Modal.getOrCreateInstance('#upgrade-eits-modal').show();
	});
	$('#upgrade-eits-modal').on('hidden.bs.modal', (e) => {
		isDryRun = true;
		$(e.target).find('.loader').addClass('d-none');
		$(e.target).find('.meta').addClass('d-none');
		$('#confirm-upgrade-eits-version').removeClass('btn-danger').addClass('btn-primary');
	});

	$('#confirm-upgrade-eits-version').click(() => {
		const mod = $('#upgrade-eits-modal');
		const loader = mod.find('.loader').removeClass('d-none');

		submitAjaxGet('/api/upgradeVersion/' + isDryRun).then(
			(resp) => {
				if (typeof resp.data === 'string') {
					localStorage.setItem('eits-toast-msg-success', resp.data);
					document.location.href = '/app';
				} else {
					mod.find('.auto-migrated-modules').text(resp.data.AutoMigratedModules);
					mod.find('.auto-migrated-methods').text(resp.data.AutoMigratedMethods);
					mod.find('.auto-migrated-rules').text(resp.data.AutoMigratedRules);
					mod.find('.added-modules').text(resp.data.AddedModules);
					mod.find('.added-methods').text(resp.data.AddedMethods);
					mod.find('.added-rules').text(resp.data.AddedRules);
					mod.find('.substantially-changed-methods').text(resp.data.SubstantiallyChangedMethods);
					mod.find('.substantially-changed-rules').text(resp.data.SubstantiallyChangedRules);
					mod.find('.deleted-modules').text(resp.data.DeletedModules);
					mod.find('.deleted-methods').text(resp.data.DeletedMethods);
					mod.find('.deleted-rules').text(resp.data.DeletedRules);

					loader.addClass('d-none');
					mod.find('.meta').removeClass('d-none');
					$('#confirm-upgrade-eits-version').removeClass('btn-primary').addClass('btn-danger');
					isDryRun = false;
				}
			},
			(error) => {
				loader.addClass('d-none');
				if (error && error.errors) {
					showToast(error.errors.detail, 'error');
				}
			},
		);
	});

	$(document).ready(() => {
		const msg = localStorage.getItem('eits-toast-msg-success');
		if (msg) {
			localStorage.removeItem('eits-toast-msg-success');
			showToast(msg, 'success');
		}
	});

	// Close properties panel
	$('.close-properties').click(function (e) {
		e.preventDefault();
		openProperties();
	});

	// Checkbox
	$('.checkbox-container').click(function (e) {
		let dataID = $(this).data('id');
		let element = $(this).find('input[type=checkbox]');
		if (element.is(':checked')) {
			element.attr('checked', 'checked');
			$('#bp-' + dataID).fadeIn();
		} else if (element.is(':not(:checked)')) {
			element.removeAttr('checked');
			$('#bp-' + dataID).fadeOut();
		}
	});

	$('.lang-selector').click(function (e) {
		e.preventDefault();

		let lang = $(e.currentTarget).data('lang');

		submitAjaxGet('/lang/' + lang).then(function (resp) {
			window.location.reload();
		});
	});
}

function submitAjaxGet(route) {
	var promise = new Promise((resolve, reject) => {
		$.ajax({
			type: 'GET',
			url: route,
			success: function (html) {
				resolve(html);
			},
			error: function (jqXHR, status, error) {
				if (jqXHR.status == 403) {
					window.location.href = '/';
					return;
				}
				reject(jqXHR.responseJSON);
			},
		});
	});

	return promise;
}

function showToast(message, type) {
	if (type === 'success') toaster.showSuccess(message);
	else toaster.showError(message);
}
